/* eslint-disable import/no-internal-modules */
/* eslint-disable boundaries/element-types */
import { useEffect } from 'react';
import { toast } from 'sonner';

import { socket } from '~/shared/api/socket';

import { useSupportChats, useSupportPageMessages } from '~/pages/support/model';

export function useSocketForSupportChat() {
  const {
    setChats,
    setActiveStatus,
    changeChatStatus,
    assignAdmin,
    setActiveChat,
  } = useSupportChats();
  const { addMessages } = useSupportPageMessages();
  const user = JSON.parse(localStorage.getItem('user-storage') as string);
  const role = user?.state?.user?.role || ' ';
  useEffect(() => {
    socket.emit('connetion');

    if (user?.state?.user?.email) {
      socket.emit('joinByUserName', user.state.user.email);
    }
    if (role === 'admin') {
      socket.emit('join-admin-room');
    }
    socket.on('create-chat', (chat) => {
      assignAdmin(chat.admin, chat.id);
      changeChatStatus(chat.id, 'open');
      setActiveStatus('open');
      if (role !== 'admin') {
        setActiveChat(chat.id);
      }
      toast.success('new chat started');
    });
    socket.on('add-user-to-queue', (chatData) => {
      setChats(chatData);
      // setSortedChatList(chats);
      toast.success('new chat request');
    });
    socket.on('close-chat', (chatId) => {
      changeChatStatus(chatId, 'closed');
      toast.success('chat closed');
    });
    socket.on('getMsg', ({ id, creator, chat, text }) => {
      addMessages({
        id,
        creator,
        chat,
        text,
      }); // add to db
      toast.success('new message');
    });
    return () => {
      socket.off('getMsg');
      socket.off('create-chat');
      socket.off('add-user-to-queue');
      socket.off('close-chat');
    };
  }, [
    setActiveStatus,
    setChats,
    addMessages,
    changeChatStatus,
    setActiveChat,
    assignAdmin,
    role,
    user?.state?.user?.email,
  ]);
}
